
    // This will be stripped in dist by scripts/package_static.js
    try { await import('/src/solid/main.tsx'); } catch(e) { /* dev only */ }
